'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'face-awesome';
var width = 512;
var height = 512;
var aliases = ["gave-dandy"];
var unicode = 'e409';
var svgPathData = 'M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM192 224l-112 0 0-32c0-30.9 25.1-56 56-56 .9 0 1.8 0 2.8 .1-6.6 5.9-10.8 14.4-10.8 23.9 0 17.7 14.3 32 32 32 12.8 0 23.8-7.5 28.9-18.3 2 5.7 3.1 11.9 3.1 18.3l0 32zM136 120c-39.8 0-72 32.2-72 72l0 48 144 0 0-48c0-39.8-32.2-72-72-72zm40 40a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm200 8a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-21.2-39.9c-6.6 5.9-10.8 14.4-10.8 23.9 0 17.7 14.3 32 32 32 15.1 0 27.8-10.5 31.1-24.5 5.6 9.5 8.9 20.7 8.9 32.5l0 32-128 0 0-32c0-35.3 28.7-64 64-64 .9 0 1.8 0 2.8 .1zM272 192l0 48 160 0 0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm89.9 187.8c-27.7 32.1-68.6 52.2-113.9 52.2-2.1 0-4.3 0-6.4-.1 7.5-36.4 39.7-63.9 78.4-63.9 15.4 0 29.7 4.3 41.9 11.8zm12.8-10.7c-15.5-10.8-34.4-17.1-54.8-17.1-47 0-86.1 33.8-94.4 78.4-71.8-10.1-129-68.4-136.1-142.4l317 0c-2.9 30.5-14.3 58.3-31.7 81.1zM248 448c90.6 0 166.3-69.1 174.5-159.3l.1-.7 1.5-16-352 0 1.5 16 .1 .7C81.7 378.9 157.4 448 248 448z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceAwesome = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;